import React from 'react'
import RoomTypeRendererHelper from '../../../components/AgGrid/RendererHelper/RoomTypeRendererHelper'

const RoomTypeRenderer = (props) => {
  const { value } = props
  return <RoomTypeRendererHelper value={value} />
}

export default RoomTypeRenderer
